import { render, staticRenderFns } from "./BackofficeConfirmarTriagem.vue?vue&type=template&id=56095e02&scoped=true"
import script from "./BackofficeConfirmarTriagem.vue?vue&type=script&lang=ts"
export * from "./BackofficeConfirmarTriagem.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeConfirmarTriagem.vue?vue&type=style&index=0&id=56095e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56095e02",
  null
  
)

export default component.exports